@if (imageSource(); as source) {
  <img
    class="cx-user-avatar__image"
    [src]="source"
    [attr.alt]="name() ?? ''"
    (error)="onImageError()" />
} @else if (fallback() === 'icon') {
  <i class="pi pi-user" aria-hidden="true" [style.font-size.px]="iconFontSize()"></i>
} @else {
  <span aria-hidden="true">{{ initials() }}</span>
}
